<template>
  <div
    class="activity_poster"
    :class="`type${type}`"
    :style="{ backgroundImage: `url(${getImageUrl('bg2@2x.png')})` }"
  >
    <div class="logo" :style="bgStyle('logo@2x.png')" />
    <div class="title" :style="bgStyle('title@2x.png')" />
    <div class="name" :style="bgStyle('xm@2x.png')">恭喜{{ name }}</div>
    <div class="ip" :style="bgStyle('ip@2x.png')" />
    <div class="center" :style="bgStyle('信息框@2x.png')">
      <p>您是今年（{{ year }}）</p>
      <div class="rank">
        入馆的第 <span>{{ allRank }}</span> 位
      </div>
      <img :src="getImageUrl('jinian@2x.png')" />
      <div class="desc" :style="bgStyle('desc.png')">
        您是今天({{ date }})入馆的第{{ rank }}位
      </div>
      <p>您是历史入馆的第{{ historyCount }}位</p>
      <p>这是您第{{ myCount }}次参观温州科技馆</p>
      <p>检票时间：{{ checkTime }}</p>
    </div>
    <div class="foot" :style="bgStyle('底部素材@2x.png')" />
    <div class="btn" :style="bgStyle('btnbg.png')">
      <div class="countdown">倒计时{{ time }}秒后关闭</div>
      <div class="close" @click="close">关闭</div>
    </div>
  </div>
</template>

<script>
const posterImages = require.context("@/assets/images/poster", true, /\.png$/);

export default {
  name: "ActivityPoster",
  data() {
    const type = this.$route.query?.type || 3;
    const data = JSON.parse(this.$route.query?.data || "{}");
    const date = new Date();
    return {
      type: parseInt(type, 10),
      name: data.name,
      year: date.getFullYear(),
      allRank: data.yearCount,
      date: date.toLocaleDateString(),
      rank: data.todayCount,
      historyCount: data.historyCount,
      myCount: data.myCount,
      checkTime: data.checkTime,
      time: this.$store.state.specialPauseSecond || 10,
      timer: null,
    };
  },
  watch: {
    "$route.query.type": {
      handler(newType) {
        if (newType) {
          this.type = parseInt(newType, 10) || 1;
        }
      },
      immediate: true,
    },
    time(val) {
      if (val === 0) this.close();
    },
  },
  mounted() {
    this.startCountdown();
  },
  beforeUnmount() {
    this.clearTimer();
  },
  methods: {
    // 获取图片 URL（根据 type 动态切换目录）
    getImageUrl(fileName) {
      try {
        // 构建相对路径，例如 "./1/logo@2x.png"
        const relativePath = `./${this.type}/${fileName}`;
        return posterImages(relativePath);
      } catch (error) {
        console.error(`图片加载失败: poster/${this.type}/${fileName}`, error);
        // 降级：尝试使用 type=1 的图片
      }
    },
    // 生成背景图片样式对象
    bgStyle(fileName) {
      return {
        backgroundImage: `url(${this.getImageUrl(fileName)})`,
      };
    },
    startCountdown() {
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.time > 0) this.time--;
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    close() {
      this.clearTimer();
      // 关闭逻辑：返回上一页或触发关闭事件
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 以下样式完全保留原始文件，未做任何修改（仅删除了原有 background-image 以避免被内联覆盖，实际保留也无影响） */
.activity_poster {
  width: 100%;
  height: 100vh;
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  position: relative;

  .logo {
    position: absolute;
    top: 10px;
    left: 18px;
    width: 42px;
    height: 61px;
    background-size: cover;
    z-index: 200;
  }
  .title {
    position: absolute;
    top: 50px;
    transform: translateX(-50%);
    left: 50%;
    width: 241px;
    height: 103px;
    background-size: cover;
    z-index: 200;
  }
  .name {
    position: absolute;
    top: 153px;
    left: 50%;
    transform: translateX(-50%);
    width: 248px;
    height: 53px;
    background-size: cover;
    z-index: 200;
    font-size: 20px;
    font-weight: bold;
    padding-top: 4px;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
  }
  .ip {
    position: absolute;
    top: 185px;
    left: 50%;
    transform: translateX(-50%);
    width: 228px;
    height: 133px;
    background-size: cover;
    z-index: 300;
  }
  .center {
    position: absolute;
    top: 263px;
    left: 50%;
    transform: translateX(-50%);
    width: 315px;
    height: 500px;
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;

    z-index: 200;
    padding-top: 50px;
    text-align: center;
    box-sizing: border-box;
    > * {
      margin-top: 8px;
      color: #000000;
      font-size: 12px;
      font-weight: bold;
    }
    .desc {
      background-size: 100%;
      margin: 0 auto;
      width: 240px;
      height: 23px;
      line-height: 23px;
    }
    .rank {
      font-size: 18px;
      font-weight: bold;
      > span {
        font-size: 22px;
        font-weight: bold;
        color: #d72004;
      }
    }
    img {
      width: 132px;
      margin-bottom: 4px;
    }
  }
  .foot {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 236px;
    background-size: cover;
    z-index: 200;
  }
  .btn {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 238px;
    height: 38px;
    background-size: cover;
    z-index: 300;
    display: flex;
    box-sizing: border-box;
    padding-left: 20px;
    justify-content: space-evenly;
    align-items: center;
    font-size: 12px;
    .countdown {
      background: #763a24;
      border-radius: 11px;
      border: 1px solid #ecbc69;
      width: 125px;
      height: 23px;
      line-height: 23px;
      text-align: center;
      color: #fff;
    }
    .close {
      width: 66px;
      height: 22px;
      border-radius: 11px;
      background: #ecbc69;
      line-height: 22px;
      text-align: center;
      cursor: pointer;
      border: 1px solid #fff;
    }
  }
}
.type1 {
  background-color: #9f0c01;
}
.type2 {
  background-color: #7df4fb;
  .foot {
    height: 360px;
  }
  .desc {
    color: #fff;
  }
  .btn {
    .countdown {
      background: #102a75;
      border: 1px solid #fff;
    }
    .close {
      background: #add0f5;
      border: 1px solid #fff;
      color: #000;
    }
  }
}
.type3 {
  background-color: #fefae8;
  .foot {
    height: 360px;
  }
  .title {
    width: 248px;
  }
  .name {
    padding-top: 8px;
    width: 214px;
    height: 61px;
  }
  .desc {
    color: #fff;
  }
  .btn {
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    .countdown {
      background: #fd7c7b;
      border: 2px solid #fff;
    }
    .close {
      background: #fd7c7b;
      border: 2px solid #fff;
      color: #fff;
    }
  }
}
</style>
